import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { generateItemImageUrl } from './utils';
import { ITEM_DESCRIPTION_UNAVAILABLE, UNAVAILABLE_IMAGE } from './constants';
import { LineItemPrice } from './LineItemPrice';

// Ported one-to-one from @thd-olt-component-react/active-orders' FulfillmentLineItems.tsx
// (OOP-4059) — see FulfillmentDetailsDrawer.tsx's doc comment.
export interface FulfillmentLineItemsProps {
  fulfillmentGroup?: any;
}

export const FulfillmentLineItems: React.FC<FulfillmentLineItemsProps> = ({ fulfillmentGroup }) => {
  if (!fulfillmentGroup?.lineItems?.length) {
    return null;
  }

  const { lineItems } = fulfillmentGroup;

  return (
    <>
      {lineItems.map((lineItem: any, index: number) => {
        const itemQuantity =
          lineItem?.currentQuantity ?? lineItem?.quantity ?? lineItem?.originalOrderedQuantity ?? lineItem?.qtyToPrint;

        const itemDetails = (
          <>
            <span className="sui-font-bold sui-pr-1">{lineItem?.brandName?.toUpperCase()}</span>
            <span>{lineItem?.description ?? lineItem?.subClassName ?? ITEM_DESCRIPTION_UNAVAILABLE}</span>
          </>
        );

        return (
          <React.Fragment key={index}>
            <div className="sui-flex sui-flex-row sui-justify-between sui-pl-2 sui-py-2" data-testid="fulfillment-line-item">
              <div className="sui-flex sui-flex-row sui-gap-4">
                <img src={generateItemImageUrl(lineItem)} alt={lineItem?.description || UNAVAILABLE_IMAGE} width="50" height="50" />
                <div className="sui-max-w-32">
                  <Typography variant="body-sm" lineClamp={2} title={lineItem?.description || ITEM_DESCRIPTION_UNAVAILABLE}>
                    {itemDetails}
                  </Typography>
                </div>
              </div>
              <div className="sui-flex sui-flex-col sui-items-end">
                <Typography variant="h6" weight="bold">
                  <LineItemPrice quantity={lineItem?.quantity} unitPrice={lineItem?.unitPrice} />
                </Typography>
                <Typography variant="body-sm">Qty: {itemQuantity}</Typography>
              </div>
            </div>
            {index < lineItems.length - 1 && <hr className="sui-mb-4" />}
          </React.Fragment>
        );
      })}
    </>
  );
};
